export const TIMELINE_TOOLTIP_ID = 'timeline_tooltip';
export const LAYER_HEADER_WIDTH = 150;
export const LAYER_FIXED_SLIM_HEIGHT = 32;
export const CUSTOM_SCROLLBAR_SIZE = 16;
export const TIME_MEASURE_HEIGHT = 30;
export const CONTROLS_SIZE = 44;
export const SPLIT_SCROLLBOX_CONTROL_HEIGHT = 10;
export const MIN_PIXELS_PER_SECOND = 20;
export const DEFAULT_PIXELS_PER_SECOND = 40;
export const MAX_PIXELS_PER_SECOND = 300;
export const MAX_TRACK_HEIGHT = 60;
export const DEFAULT_TRACK_HEIGHT = 40;
export const MIN_TRACK_HEIGHT = 30;

export enum LayerType {
  FixedSlim = 'fixed-slim',
  Zoomable = 'zoomable'
}
